import { dictateOnboardingWizard, type DictateStep } from './dictate-onboarding.wizard';

export type { DictateStep };

/**
 * All declared steps in forward order. Navigation itself lives in the wizard
 * (`dictate-onboarding.wizard.ts`, run by `DictateOnboardingProvider`); this
 * list backs persistence validation and the pre-auth resume window.
 */
export const VISIBLE_STEPS: readonly DictateStep[] = dictateOnboardingWizard.stepIds;

/** Pre-auth steps persisted to disk for resume across app restarts. */
export const PRE_AUTH_STEPS: DictateStep[] = VISIBLE_STEPS.slice(
  0,
  VISIBLE_STEPS.indexOf('sign-in') + 1
);

export const PRE_AUTH_STEP_SET = new Set<string>(PRE_AUTH_STEPS);

/**
 * Returns the next linear step, or null if this is the last step. Used outside
 * the provider (e.g. computing the post-sign-in landing step) — in-flow
 * navigation goes through the wizard instead.
 */
export function getNextStep(
  step: DictateStep,
  steps: readonly DictateStep[] = VISIBLE_STEPS
): DictateStep | null {
  const idx = steps.indexOf(step);
  if (idx === -1 || idx === steps.length - 1) return null;
  return steps[idx + 1] ?? null;
}
